import React from 'react';
import './index.css';
import clsx from 'classnames';
import { Position } from 'components';
import QueueAnim from 'rc-queue-anim';
import { usePageTitle } from '../../hooks';

const Contact = () => {
  // 设置页面标题
  usePageTitle('联系我们');

  return (
    <div
      className={clsx('contact-top')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部Banner */}
      <div className={clsx('contact-top-img')}>
        <div className={clsx('contact-top-img-content')}>
          <div className={clsx('contact-top-img-content-title')}>
            与之阳携手打造<span>现代化实验室体系</span>
          </div>
          <div className={clsx('contact-top-img-content-desc')}>
            Work hand in hand with Zhiyang to build a modern laboratory system
          </div>
        </div>
      </div>
      {/* 当前位置 */}
      <Position list={['首页', '联系我们']} />
      {/* 联系我们 */}
      <QueueAnim className={clsx('contact-content')} type={['right', 'left']}>
        <QueueAnim
          className={clsx('contact-content-left')}
          key={'one'}
          type={'bottom'}
        >
          <div className={clsx('contact-content-left-title')}>联系我们</div>
          <div className={clsx('contact-content-left-info')}>
            <QueueAnim
              className={clsx('contact-content-left-info-item')}
              type={'bottom'}
            >
              <div
                className={clsx('contact-content-left-info-item-text')}
                key={1}
              >
                传真：0571-88722230
              </div>
              <div
                className={clsx('contact-content-left-info-item-text')}
                key={2}
              >
                联系电话：0571-88722230
              </div>
              <div
                className={clsx('contact-content-left-info-item-text')}
                key={3}
              >
                网址：www.zjzyyq.cn
              </div>
              <div
                className={clsx('contact-content-left-info-item-text')}
                key={4}
              >
                崔经理：139-8945-4782
              </div>
              <div
                className={clsx('contact-content-left-info-item-text')}
                key={5}
              >
                公众号：之阳智造
              </div>
              <div
                className={clsx('contact-content-left-info-item-text')}
                key={6}
              >
                潘经理：138-0680-7001
              </div>
              <div
                className={clsx('contact-content-left-info-item-img')}
                key={7}
              >
                <img src='/img/cui.png' alt='' />
                <div>崔经理</div>
              </div>
              <div
                className={clsx('contact-content-left-info-item-img')}
                key={8}
              >
                <img src='/img/pan.png' alt='' />
                <div>潘经理</div>
              </div>
            </QueueAnim>
          </div>
        </QueueAnim>
        <QueueAnim
          className={clsx('contact-content-right')}
          key='two'
          type={['right', 'left']}
        >
          <div
            className={clsx('contact-content-left-title')}
            key='contact-content-left-title'
          >
            公司地址
          </div>
          <div
            className={clsx('contact-content-right-info')}
            key='contact-content-right-info'
          >
            <div className={clsx('contact-content-right-info-item')}>
              <img src='/img/address.png' alt='' />
              <div className={clsx('contact-content-right-info-item-text')}>
                地址：浙江省余杭区瓶窑镇崇化村嵩山头51号南佳科技园1幢
              </div>
            </div>
          </div>
        </QueueAnim>
      </QueueAnim>
    </div>
  );
};

export default Contact;
